import { useState, useEffect, useRef } from "react";

export default function SeasonBar({selectedShow, selectedSeason, setSelectedSeason, seasonDDOpen, setSeasonDDOpen, episodes, seasonStatuses}) {

    const seasonRef = useRef(null);

    const [episodesBySeason, setEpisodesBySeason] = useState([]);
    
    useEffect(() => {
        setEpisodesBySeason(episodes?.filter(ep => Number(ep.seasonNumber) === Number(selectedSeason)));
    }, [episodes, selectedSeason]);
    

     // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (seasonRef.current && !seasonRef.current.contains(event.target)) {
                setSeasonDDOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    
    return (
    <div className="seasonDropdownWrapper" ref={seasonRef}>
        {selectedShow.numberOfSeasons != 1 && <div>
            <button type="button" onClick={() => setSeasonDDOpen(!seasonDDOpen)} className="seasonDropdown"> 
                Season {selectedSeason}
                
                <span className="dropdown-arrow">&#9662;</span>
                
            </button>
            {seasonDDOpen && (
                <ul className="seasonDropdownMenu">
                {Array.from({ length: selectedShow.numberOfSeasons }, (_, i) => (
                    <li
                    key={i}
                    className={`dropdown-item ${i === selectedSeason ? "selected" : ""}`}
                    onClick={() => { 
                            setSelectedSeason(i + 1); 
                            setSeasonDDOpen(false); 
                        }
                    }
                    >
                    Season {i + 1}
                    </li>
                ))}
                </ul>
            )}
        </div>}
        {selectedShow.numberOfSeasons == 1 && <div>
            <button type="button" className="seasonHeader"> 
                Season {selectedSeason}
            </button>
        </div>}
 
        <div className="episodesWatchedBar">
            <p>{seasonStatuses.length} / {episodesBySeason.length} episodes rated</p>
        </div>
        
    </div>
    );
}
